import React from 'react'
import styles from './index.module.less'

const snap = [0, 42, 84]
const SIZE_MAP = new Map([[0, 'L'], [1, 'M'], [2, 'S']])

export const RULES = {
  L: {
    widths: [1910, 1638, 1110, 500],
    maxColumnCount: 5
  },
  M: {
    widths: [1910, 1638, 1430, 1110, 900, 700],
    maxColumnCount: 7
  },
  S: {
    widths: [1910, 1638, 1430, 1110, 900, 700, 500],
    maxColumnCount: 8
  }
}

export const getRules = (val) => RULES[SIZE_MAP.get(val)]

export default function ImageSize({ onChange, value }) {
  const onSubmit = (s, i) => {
    onChange?.(i, SIZE_MAP.get(i))
  }

  return <div className={styles.wrap}>
    <span style={{ marginRight: '8px' }}>大图</span>
    <span className={styles.line}>
      {snap.map((m, i) => <div
        key={m}
        className={styles.circle}
        style={{ left: `calc(${i}*47px)`, }}
        onClick={() => {
          onSubmit(SIZE_MAP.get(i), i)
        }}
      />) }
      <div className={styles.active} style={{ left: value * 47 }} />
    </span>
    <span style={{ marginLeft: '8px' }}>小图</span>
  </div>
}
